import { render } from "./ServerTimeMessage.vue?vue&type=template&id=207e1eb7&scoped=true&ts=true"
import script from "./ServerTimeMessage.vue?vue&type=script&lang=ts"
export * from "./ServerTimeMessage.vue?vue&type=script&lang=ts"

import "./ServerTimeMessage.vue?vue&type=style&index=0&id=207e1eb7&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e1eb7"]])

export default __exports__